// extracted by mini-css-extract-plugin
export default {"active":"ButtonPay_active__7ctbe","default":"ButtonPay_default__+w1G8"};